@if (queryParams$ | async) {}

<nz-page-header nzTitle="Релизы"></nz-page-header>
<nz-table
  #basicTable
  nzBordered
  nzShowSizeChanger
  [nzData]="releases"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzTotal]="totalReleases"
  [nzPageIndex]="pageNumber"
  (nzQueryParams)="onQueryParamsChange($event)"
  style="width: 30%"
>
  <thead>
    <tr>
      <th>Версия</th>
    </tr>
  </thead>
  <tbody>
    @for (data of basicTable.data; track $index) {
      <tr
        class="version-wrapper"
        [routerLink]="getPathToDetails(data.id)"
        [queryParams]="{ page: this.pageNumber, pageSize: this.pageSize }"
      >
        <td nzTooltipTitle="Подробнее">
          {{ data.version }}
        </td>
      </tr>
    }
  </tbody>
</nz-table>
